import { WallMovementConstraintDTO } from './WallPositionConstraintDTO';

export class MovementDataDTO {
  public static defaultValue = new MovementDataDTO(0, WallMovementConstraintDTO.defaultValue, [0, 1, 0]);

  productOffset: number;
  wallMovementConstraints: WallMovementConstraintDTO[];
  linkVector: number[];

  constructor(productOffset: number, wallMovementConstraints: WallMovementConstraintDTO[], linkVector: number[]) {
    this.productOffset = productOffset;
    this.wallMovementConstraints = wallMovementConstraints;
    this.linkVector = linkVector;
  }
}
